export const UNLIMITED_VALUE_COUPON = 100_000_000
